// A local invalidation fence, not an authorization claim or a credential key.
let generation = 0
const listeners = new Set()
export const getSessionGeneration = () => generation
export function onSessionGenerationChange(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
export function advanceSessionGeneration() {
  generation++
  for (const listener of listeners) {
    try { listener(generation) } catch { /* One cache must not block sign-out. */ }
  }
  return generation
}
export function sessionChangedError() {
  return Object.assign(new Error('The signed-in session changed. Read again in the current session.'), {name: 'AbortError', code: 'session_changed'})
}

// Cache promises only within this generation. Reset fences pending successes
// AND failures, including an explicit same-session refresh of a cached policy.
export function createSessionCache() {
  let epoch = 0
  const entries = new Map()
  const clear = () => { epoch++; entries.clear() }
  onSessionGenerationChange(clear)
  return {
    clear,
    load(key, loader) {
      if (entries.has(key)) return entries.get(key)
      const run = epoch, session = getSessionGeneration()
      const current = () => run === epoch && session === getSessionGeneration()
      const promise = Promise.resolve().then(() => {
        if (!current()) throw sessionChangedError()
        return loader()
      }).then(value => {
        if (!current()) throw sessionChangedError()
        return value
      }, error => {
        if (!current()) throw sessionChangedError()
        entries.delete(key)
        throw error
      })
      entries.set(key, promise)
      return promise
    },
  }
}
